import type { Client, RequestContext } from "../client";
import type { NewScopedUserRoleResource, ScopedUserRoleResource } from "../resources/scopedUserRoleResource";
import { MixedScopeBaseRepository } from "./mixedScopeBaseRepository";
export class ScopedUserRoleRepository extends MixedScopeBaseRepository<ScopedUserRoleResource, NewScopedUserRoleResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("ScopedUserRoles", client, requestContext);
    }
}
